<template>
  <form role="form">

    <payout-form-group :label="$t('Сеть')"
                       :required="true"
                       :has-errors="false">

      <dropdown-keyvalue :options="usdcNetworkTypeOptions"
                         :disabled="true"
                         :placeholder="$t('Выберите сеть')"
                         :value="network"></dropdown-keyvalue>

      <payout-input-hint-block v-slot:hints :hint="model.getHint('network')"></payout-input-hint-block>
    </payout-form-group>

    <payout-form-group :label="$t('Адрес получателя')"
                       class="form-group__label_align_start"
                       :required="model.isRequiredAttribute('destinationAccount')"
                       :has-errors="model.errors.has('destinationAccount')">
      <filtered-input-wrapper v-model="model.values.destinationAccount"></filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints :hint="$t(addressHintPath)"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="destinationAccount|*" :errors="model.errors"></error-message-block>
    </payout-form-group>

    <payout-textfield-input-group :model='model' attribute='description' :label="$t('Назначение платежа')"></payout-textfield-input-group>

    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>

    <payout-estimated-destination-amount-form-group :model="model"></payout-estimated-destination-amount-form-group>

    <payout-destination-currency-conversion-notice-form-group style="margin-top: 1em;"
                                              :model="model"></payout-destination-currency-conversion-notice-form-group>

    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>

    <payout-form-group>

      <div class="form-control-space">
        <payout-hint-panel v-show="true" :heading="$t('Динамическая комиссия')">
          {{ $t('tax_hint') }}
          <dynamic-fee-value-text system="USDCERC20"></dynamic-fee-value-text>
        </payout-hint-panel>
      </div>

    </payout-form-group>

    <CryptoPaymentNotice></CryptoPaymentNotice>

    <payout-form-notification-block :model="model"></payout-form-notification-block>

    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {Component} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import DynamicFeeValueText from "@/components/forms/payout/forms/crypto/DynamicFeeValueText.vue";
import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";
import CryptoPaymentNotice from "@/components/forms/payout/forms/crypto/CryptoPaymentNotice.vue";
import {UsdtNetworkType} from "@/models/finance/crypto";

export class UsdcPayoutModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.USDC

  required = [
    'amount', 'description', 'fromAccount',
    'destinationAccount',
    'verificationType'
  ]

  values = {
    network: 'ethereum',
    fromAccount: '', amount: '', label: '',
    verificationType: '', destinationAccount: ''
  }

}

@Component({
  name: "UsdcPaymentForm",
  components: {
    CryptoPaymentNotice,
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    DynamicFeeValueText,
    DropdownKeyvalue,
    PayoutHintPanel,
    FilteredInputWrapper,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutToggableHintPanelFormGroup,
    PayoutEvaluateFeeFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup, ErrorMessageBlock, PayoutInputHintBlock, PayoutFormGroup}
})
export default class UsdcPaymentForm extends AbstractPayoutForm {
  model = new UsdcPayoutModel();

  network = 'ethereum';

  get addressHintPath() {
    return 'address_hint';
  }

  get usdcNetworkTypeOptions() {
    return {
      [UsdtNetworkType.Ethereum]: 'Ethereum (ERC20)',
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Номер кошелька": "Wallet number",
    "Назначение платежа": "Description",
    "Адрес получателя": "Beneficiary address",
    "address_hint": "USDC address.",
    "address_hint_ethereum": "USDC address.",
    "address_hint_tron": "USDC address.",
    "Динамическая комиссия": "Dynamic commission",
    "tax_hint": "Please notice, the USDC payment's commission is dynamic and it is updating every few minutes.",
    "Сеть": "Network"
  },
  "ru": {
    "address_hint": "Адрес USDC для переводов со счета USDC.",
    "address_hint_ethereum": "Адрес USDC для переводов со счета USDC.",
    "address_hint_tron": "Адрес USDC для переводов со счета USDC.",
    "tax_hint": "Обратите внимание, что комиссия за платежи на адреса USDC динамическая и обновляется каждые несколько минут."
  }
}
</i18n>
